import { Box, FormControl } from "@mui/material";
import {
  CertifikatPotvrdaDialog,
  DragAndDrop,
  PorukaGreskePolja,
} from "../../../index";
import Button from "@mui/material/Button";
import { useFormContext } from "react-hook-form";
import { TIP_INFO_PORUKE } from "../../../../enums";
import axios from "axios";
import { Context } from "../../../../context";
import { useCallback, useContext, useState } from "react";

const Index = () => {
  const { getValues, setError, setValue, watch } = useFormContext();
  const certifikat = getValues("certifikat");
  const [open, setOpen] = useState(false);
  const setCertifikatPotvrdaDialogOpen = useCallback((opened: boolean) => {
    setOpen(false);
  }, []);
  const [data] = useContext(Context);
  const { token } = data;

  const openDialog = () => {
    const certifikatPostoji = watch("certifikatPostoji");
    const javniKljucPostoji = watch("certifikat");
    if (
      certifikatPostoji ||
      (javniKljucPostoji && javniKljucPostoji.size > 0)
    ) {
      setOpen(true);
    } else {
      prenesiJavniKljuc();
    }
  };
  const prenesiJavniKljuc = useCallback(async () => {
    setValue("loading", true);
    setOpen(false);

    const javniKljuc = getValues("javniKljuc");
    const formData = new FormData();
    formData.append("csrFile", javniKljuc || "");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/operateri/upload-csr`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { status } = response;
      if (status === 200) {
        setValue("infoPoruka", response.data.message);
        setValue("tipInfoPoruke", TIP_INFO_PORUKE.SUCCESS);
      }
    } catch (error: any) {
      const { status } = error.response;
      if (status === 400 || status === 500) {
        if (error.response.data.message) {
          setValue("infoPoruka", error.response.data.message);
          setValue("tipInfoPoruke", TIP_INFO_PORUKE.ERROR);
        }
      }
    } finally {
      setValue("loading", false);
    }
  }, []);
  return (
    <div>
      <h5>Prenesi CSR datoteku (Transmit CSR file)</h5>
      <FormControl fullWidth variant="outlined">
        <DragAndDrop
          nazivPolja={"javniKljuc"}
          label={"*Prenesi datoteku (Transmit file)"}
        />
      </FormControl>
      <PorukaGreskePolja nazivPolja={"javniKljuc"} />
      <Box
        display={"flex"}
        justifyContent={"flex-end"}
        alignItems={"flex-end"}
        mt={1}
      >
        <Button type={"button"} variant={"contained"} onClick={openDialog}>
          Prenesi CSR datoteku (Transmit CSR file)
        </Button>
      </Box>
      <CertifikatPotvrdaDialog
        open={open}
        setOpen={setCertifikatPotvrdaDialogOpen}
        prenesiJavniKljuc={prenesiJavniKljuc}
      />
    </div>
  );
};

export default Index;
